        //functions4push
        export function initialiseServiceWorker () {
          if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
            console.log('Notifications aren\'t supported.')
            return
          }

          if (Notification.permission === 'denied') {
            console.log('The user has blocked notifications.')
            return
          }

          if (!('PushManager' in window)) {
            console.log('Push messaging isn\'t supported.')
            return
          }

          navigator.serviceWorker.ready.then(registration => {
            registration.pushManager.getSubscription()
              .then(subscription => {
                if (!subscription) {
                  return
                }
                //updateSubscription(subscription)
              })
              .catch(e => {
                console.log('Error during getSubscription()', e)
              })
          })
        }
        export function registerServiceWorker () {
          if (!('serviceWorker' in navigator)) {
            console.log('Service workers aren\'t supported in this browser.')
            return
          }

          navigator.serviceWorker.register('/sw.js')
            .then(() => initialiseServiceWorker())
        }
        export function updateSubscription (subscription) {
          const key = subscription.getKey('p256dh')
          const token = subscription.getKey('auth')
          const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0]
          const data = {
            endpoint: subscription.endpoint,
            publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
            authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
            slug: window.self.location.pathname,
            contentEncoding
          }
          axios.post('/subscriptions', data)
            .then(() => {
                  if ($('.push_enabled').length){
                      $(".push_enabled").show()
                  }
                  if ($('.push_loading').length){
                      $(".push_loading").hide()
                  }
          })
      }
      export function urlBase64ToUint8Array (base64String) {
          const padding = '='.repeat((4 - base64String.length % 4) % 4)
          const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/')

          const rawData = window.atob(base64)
          const outputArray = new Uint8Array(rawData.length)

            for (let i = 0; i < rawData.length; ++i) {
              outputArray[i] = rawData.charCodeAt(i)
            }
            return outputArray
        }
        export function subscribe () {
            if (window.location.pathname != "/en/alerts" && window.location.pathname != "/benachrichtigungen") {
              /*
              $("body").prepend('<div class="modal" id="show-subscription" tabindex="-1" role="dialog"> \
              <div class="story4topic modal-dialog" role="document">\
                <div class="modal-content">\
                  <div class="modal-header p-2">\
                    <h4 class="modal-title">' + (Notification.permission !== 'granted' ? messages.no_permission : messages.push_linktext) + '</h4>\
                    <button type="button" class="close" data-dismiss="modal" onclick="$(\'.modal\').modal(\'hide\');" aria-label="Close">\
                      <span aria-hidden="true">&times;</span>\
                    </button>\
                  </div>\
                  <div class="modal-body p-2">\
                    <p>' + messages.push_message + '<br><center><a href="/' + messages.push_slug + '">'+ messages.push_linktext +'</a></center></p>\
                  </div>\
                  <div class="modal-footer p-2">\
                    <button type="button" class="btn btn-secondary" onclick="$(\'.modal\').modal(\'hide\');" data-dismiss="modal">Close</button>\
                  </div>\
                </div>\
              </div>\
              </div>');  $(".modal").modal('show');*/
            }
            navigator.serviceWorker.ready.then(registration => {
                registration.pushManager.getSubscription()
                .then(function(subscription) {  
                 /*
                    if(Notification.permission !== 'denied' && !subscription && !document.cookie.includes("pushread=YES")) {
                        $("body").prepend('<div id="show-subscription" class="thankyou card" onclick="$(\'#show-subscription\').css(\'display\', \'none\');document.cookie=\'pushread=YES; expires=' + (new Date(new Date().getTime()+51840000)) + ';path=/\';" style="position:fixed;cursor:pointer;text-align:right;z-index:9999;left:10px;padding:20px;"> \
                        <h2 style="margin-right:20px">Bleib informiert</h2> \
                        Wir bieten die Möglichkeit einer Benachrichtigung für neue Themen,<br> \
                         Änderungen an bestehenden Themen oder Ankündigungen.<hr> \
                        Die Erlaubnis für die Benachrichtigungen <br>kann jederzeit in den Einstellungen des Browsers geändert werden.\
                        <button class="btn btn-primary" onclick="$(\'#show-subscription\').css(\'display\', \'none\');" style="position: absolute;    right: 0px;    top: 0px;"> \
                        X \
                        </button> \
                        </div>');
                    }*/


              });

            const options = { userVisibleOnly: true }
            const vapidPublicKey = window.userdata.vapidPublicKey
            if (vapidPublicKey) {
              options.applicationServerKey = urlBase64ToUint8Array(vapidPublicKey)
            }

            registration.pushManager.subscribe(options)
              .then(subscription => {
                updateSubscription(subscription)
              })
              .catch(e => {
                  if ($('.push_disabled').length){
                      $(".push_disabled").show()
                  }
                  if ($('.push_loading').length){
                      $(".push_loading").hide()
                  }
                if (Notification.permission === 'denied') {                    
                  console.log('Permission for Notifications was denied')                        
                } else {
                  console.log('Unable to subscribe to push.', e)
                }
              })
          })
        }
